import React, { useState } from 'react';
import { Container, Row, Col, Card, Button, Form, Alert } from 'react-bootstrap';
import { FaEnvelope, FaStar, FaCheckCircle, FaBolt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';

const Subscribe = () => {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [tier, setTier] = useState('free');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        
        // Simulate API call
        setTimeout(() => {
            setIsSubmitting(false);
            setShowSuccess(true);
            setTimeout(() => {
                navigate('/');
            }, 3000);
        }, 1500);
    };

    return (
        <div className="pricing-hero">
            <Container>
                <Row className="py-5">
                    <Col lg={8} className="mx-auto text-center">
                        <h1 className="display-3 fw-bold mb-4" style={{background: 'linear-gradient(135deg, #FF6B6B 0%, #4ECDC4 100%)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent'}}>
                            Stay Ahead with AI News
                        </h1>
                        <p className="lead mb-5" style={{fontSize: '1.25rem', color: '#6c757d'}}>
                            Get curated AI news and tools delivered to your inbox. Join thousands of professionals staying on the cutting edge.
                        </p>
                    </Col>
                </Row>
            </Container>
            
            <Container className="pb-5">
                <Row className="justify-content-center">
                    <Col lg={6}>
                        <Card className="border-0 shadow-sm p-4">
                            <Card.Body>
                                <div className="text-center mb-4">
                                    <FaEnvelope style={{fontSize: '3rem', color: '#4ECDC4'}} />
                                    <h3 className="mt-3 mb-2">Choose Your Plan</h3>
                                </div>

                                {showSuccess && (
                                    <Alert variant="success" className="mb-4">
                                        <FaCheckCircle className="me-2" />
                                        Successfully subscribed! Check your email for confirmation.
                                    </Alert>
                                )}

                                <Form onSubmit={handleSubmit}>
                                    <Form.Group className="mb-4">
                                        <Form.Label>Email Address</Form.Label>
                                        <Form.Control
                                            type="email"
                                            placeholder="Enter your email"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                        />
                                    </Form.Group>

                                    <Form.Group className="mb-4">
                                        <Form.Label>Subscription Tier</Form.Label>
                                        <div className="tier-options">
                                            <div className={`tier-option ${tier === 'free' ? 'active' : ''}`} onClick={() => setTier('free')}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h5 className="mb-1">Free</h5>
                                                        <small className="text-muted">Weekly digest</small>
                                                    </div>
                                                    <span className="fw-bold">$0</span>
                                                </div>
                                            </div>
                                            <div className={`tier-option ${tier === 'pro' ? 'active' : ''}`} onClick={() => setTier('pro')}>
                                                <div className="d-flex justify-content-between align-items-center">
                                                    <div>
                                                        <h5 className="mb-1">
                                                            <FaStar className="text-warning me-1" />
                                                            Pro
                                                        </h5>
                                                        <small className="text-muted">Daily customized news</small>
                                                    </div>
                                                    <span className="fw-bold">$3.99/mo</span>
                                                </div>
                                            </div>
                                        </div>
                                    </Form.Group>

                                    <Button 
                                        variant="primary" 
                                        type="submit" 
                                        className="w-100"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? 'Subscribing...' : 'Subscribe Now'}
                                    </Button>
                                </Form>

                                <div className="mt-4 text-center">
                                    <small className="text-muted">
                                        No spam. Unsubscribe anytime. Pro users get personalized AI recommendations.
                                    </small>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>
                </Row>

                <Row className="mt-5">
                    <Col lg={10} className="mx-auto">
                        <h3 className="text-center mb-4">What You'll Get</h3>
                        <Row>
                            <Col md={4} className="text-center mb-3">
                                <FaBolt style={{fontSize: '2rem', color: '#FF6B6B'}} />
                                <h5 className="mt-2">Latest AI Tools</h5>
                                <p className="text-muted">Discover new AI tools before they go viral</p>
                            </Col>
                            <Col md={4} className="text-center mb-3">
                                <FaStar style={{fontSize: '2rem', color: '#4ECDC4'}} />
                                <h5 className="mt-2">Curated News</h5>
                                <p className="text-muted">Only the most important AI updates</p>
                            </Col>
                            <Col md={4} className="text-center mb-3">
                                <FaCheckCircle style={{fontSize: '2rem', color: '#96CEB4'}} />
                                <h5 className="mt-2">Pro Insights</h5>
                                <p className="text-muted">Expert analysis and use cases</p>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </div>
    );
};

export default Subscribe;
